import { render, staticRenderFns } from "./commenter.vue?vue&type=template&id=7252e114&"
import script from "./commenter.vue?vue&type=script&lang=js&"
export * from "./commenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports